const API_URL = (import.meta.env.VITE_API_URL || "/api").replace(/\/$/, "");
const TOKEN_KEY = "harambee_employee_token";
type FetchOptions = NonNullable<Parameters<typeof fetch>[1]>;

export class ApiError extends Error {
  status: number;
  errors: Record<string, string>;

  constructor(message: string, status: number, errors: Record<string, string> = {}) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.errors = errors;
  }
}

export async function apiRequest<T>(path: string, options: FetchOptions = {}): Promise<T> {
  const token = localStorage.getItem(TOKEN_KEY);
  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  const body = await response.json().catch(() => ({ message: "The server returned an invalid response." }));
  if (!response.ok) {
    if (response.status === 401) localStorage.removeItem(TOKEN_KEY);
    throw new ApiError(body.message || "Request failed.", response.status, body.errors || {});
  }
  return body as T;
}

export async function submitForm(formType: string, form: HTMLFormElement, extra: Record<string, string> = {}) {
  const data = Object.fromEntries(
    Array.from(new FormData(form).entries()).map(([key, value]) => [key, String(value)])
  );
  return apiRequest<{ success: true; submission_id: number; message: string }>("/submissions", {
    method: "POST",
    body: JSON.stringify({ form_type: formType, data: { ...data, ...extra } }),
  });
}

export const authToken = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (token: string) => localStorage.setItem(TOKEN_KEY, token),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};
